import { View, Text, Modal, Image, TouchableOpacity } from "react-native";
import React, { useState } from "react";
import ImageViewer from "react-native-image-zoom-viewer";
import {
  chatMeSenderBackground,
  chatNotMeSenderBackground,
} from "../../../colors";
import { AntDesign } from "@expo/vector-icons";
import MessageStatus from "./MessageStatus";

export default function ImageMessage(props) {
  const { meSender, uri, status, sender } = props;
  const [imageOpen, setImageOpen] = useState(false);
  return (
    <View
      style={{
        alignItems: meSender ? "flex-start" : "flex-end",
        marginVertical: 10,
      }}
    >
      <Modal visible={imageOpen} transparent={true}>
        <ImageViewer
          renderHeader={() => (
            <View
              style={{ width: "100%", alignItems: "flex-start", marginTop: 60 }}
            >
              <TouchableOpacity onPress={() => setImageOpen(false)}>
                <AntDesign name="arrowright" size={24} color="white" />
              </TouchableOpacity>
            </View>
          )}
          onSwipeDown={() => setImageOpen(false)}
          enableSwipeDown={true}
          imageUrls={[
            {
              url: uri,
            },
          ]}
        />
      </Modal>
      <View
        style={{
          width: "65%",
          minHeight: 50,
          borderWidth: 1,
          borderRadius: 10,
          borderTopRightRadius: meSender ? 10 : 0,
          borderTopLeftRadius: meSender ? 0 : 10,
          marginVertical: 5,
          marginHorizontal: 10,
          paddingHorizontal: 10,
          paddingVertical: 5,
          flexDirection: meSender ? "row" : "row-reverse",
          alignItems: "center",
          overflow: "hidden",
          borderColor: "#ddd",
          backgroundColor: props.meSender
            ? chatMeSenderBackground
            : chatNotMeSenderBackground,
        }}
      >
        <TouchableOpacity onPress={() => setImageOpen(true)}>
          <Image
            source={{ uri: uri }}
            style={{ width: 200, height: 200 }}
            resizeMode="contain"
          />
        </TouchableOpacity>
      </View>
      <View
        style={{
          flexDirection: meSender ? "row" : "row-reverse",
          width: "65%",
        }}
      >
        <View style={{ flex: 1 }}></View>
        <MessageStatus meSender={sender === "doctor"} status={status} />
      </View>
    </View>
  );
}
